module.exports = __webpack_public_path__ + "static/media/stop.d4d69ca3.svg";